<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="项目单位：" prop="pid">
                <el-input :value="pnames[0]" disabled></el-input>
            </el-form-item>
            <el-form-item label="单位工程：">
                <el-input :value="pnames[1]" disabled></el-input>
            </el-form-item>
            <el-form-item label="分部工程：">
                <el-input :value="pnames[2]" disabled></el-input>
            </el-form-item>
            <el-form-item label="单元工程：">
                <el-input :value="pnames[3]" disabled></el-input>
            </el-form-item>
            <el-form-item label="孔号：" prop="hole_code">
                <el-input v-model="model.hole_code"></el-input>
            </el-form-item>
            <el-form-item label="起始高程：" prop="elevation_start">
                <el-input v-model="model.elevation_start"></el-input>
            </el-form-item>
            <el-form-item label="结束高程：" prop="elevation_end">
                <el-input v-model="model.elevation_end"></el-input>
            </el-form-item>
            <el-form-item label="孔深：" prop="deep">
                <el-input v-model="model.deep"></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input type="textarea" :rows="4" v-model="model.remark"></el-input>
            </el-form-item>
            <el-form-item label="顺序：" prop="order_index">
                <el-input v-model.number="model.order_index"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { getModelById, saveModel } from '@/api/common'
import { getProjectDivisionParentNames } from '@/api/org'

export default {
    name: 'workHoleEdit',
    mixins: [editutil],
    props: {
        pid: {
            type: Number,
            default() {
                return 0;
            }
        }
    },
    data() {
        return {
            model: {
                pid1: '',
                pid2: '',
                pid3: '',
                pid4: '',
                unit_code: '',
                unit_name: '',
                hole_code: '',
                hole_order: '',
                grout_type: '',
                remark: '',
                order_index: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/workholecheck/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                hole_code: [
                    {required: true, message: '孔号不能为空', trigger: 'blur'},
                    {validator: this.validExist, trigger: 'blur' }
                ],
                elevation_start: [
                    {validator: this.validDouble, trigger: 'blur' }
                ],
                elevation_end: [
                    {validator: this.validDouble, trigger: 'blur' }
                ],
                deep: [
                    {validator: this.validDouble, trigger: 'blur' }
                ],
                order_index: [
                    {required: true, message: '顺序不能为空', trigger: 'blur'},
                    {type: 'number', message: '顺序必须是数字值', trigger: 'blur'}
                ],
            },
            pnames: [],
            checkObj:{
                url:'/api/admin/workholecheck/check',
                data:{}
            },
            exits_p_name:'hole_code',
            exits_p_title:'孔号',
        };
    },
    methods: {
        getModelData() {
            this.model = this.copyObj(this.init_model);
            if (this.id > 0) {
                this.getObj.data.value = this.id;
                getModelById(this.getObj).then(res => {
                    if (res.code === 1) {
                        this.model = res.data;
                        if (this.exits_p_name != '') {
                            this.old_check = this.model[this.exits_p_name];
                        }
                        getProjectDivisionParentNames(this.model.pid4).then(res=>{
                            if(res.code ==1){
                                this.pnames = res.data
                            }
                        })
                        this.formateData();
                    } else {
                        this.$msg(res.msg)
                        this.closeDialog()
                    }
                })
            }else{
                getProjectDivisionParentNames(this.pid).then(res=>{
                    if(res.code ==1){
                        this.pnames = res.data
                    }
                })
            }
        },
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/workholecheck/save'
                    }
                    if (!(this.id > 0)) {
                        this.model.pid4 = this.pid
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
    }
};
</script>